import React from 'react';
import { Icon, List } from "semantic-ui-react";
import { AnswerFlag } from "./AnswerFlag";

export function AnswersList({answs}) {
	const val = Object.keys(answs||{}).map(k=>(
		<div key={k}>
			<i>{answs[k].q}</i>{" "}
			<b className="whitespace-nowrap">
				{answs[k].a}
				{['p', 'f'].includes(answs[k].r) && <> <Icon color={answs[k].r == 'p' && 'green' || 'red'} name={answs[k].r == 'p' && 'check' || 'close'}/> </>}
			</b>{" "}
			{answs[k].f && <div className="mb-2 ml-2"><AnswerFlag flg_id={answs[k].f.f} /></div>}
		</div>
	));

	return <List items={val} />;
}
